module.exports = __webpack_public_path__ + "img/stake-unstake-parsomen-empty.fcce07f8.png";